import {
  REQUEST_GEOCODER_SEARCH,
  RESPONSE_GEOCODER_SEARCH,
  REQUEST_GEOCODER_SEARCH_FAILURE,
  SELECT_GEOCODER_SEARCH,
  UNSELECT_GEOCODER_SEARCH,
  CLEAR_GEOCODER_SEARCH,
  SET_GEOCODER_SEARCH_DATA,
} from "../actions/geocoderActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  searchDataState: queriesStates.NOT_REQUESTED,
  geocoderSearchResult: [],
  selectedGeocoderSearch: null,
  dataSearch: null,
  errors: [],
};

const geocoderReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GEOCODER_SEARCH: {
      return Object.assign({}, state, {
        searchDataState: queriesStates.REQUEST,
        geocoderSearchResult: [],
      });
    }
    case RESPONSE_GEOCODER_SEARCH: {
      return Object.assign({}, state, {
        searchDataState: queriesStates.READY,
        geocoderSearchResult: action.data.items,
      });
    }
    case REQUEST_GEOCODER_SEARCH_FAILURE: {
      return Object.assign({}, state, {
        searchDataState: queriesStates.FAILURE,
        geocoderSearchResult: [],

        errors: action.errors,
      });
    }

    case SELECT_GEOCODER_SEARCH: {
      return Object.assign({}, state, {
        selectedGeocoderSearch: action.data,
      });
    }

    case UNSELECT_GEOCODER_SEARCH: {
      return Object.assign({}, state, {
        selectedGeocoderSearch: null,
      });
    }

    case SET_GEOCODER_SEARCH_DATA: {
      return Object.assign({}, state, {
        dataSearch: action.data,
      });
    }

    case CLEAR_GEOCODER_SEARCH: {
      return Object.assign({}, state, {
        selectedGeocoderSearch: null,
        geocoderSearchResult: [],
        dataSearch: null,
        errors: [],
      });
    }

    default:
      return state;
  }
};

export default geocoderReducer;
